const StaffAttendance = {
    staffAttendance: "Staff Attendance",
    subtitle: "Track daily staff attendance and mark status quickly.",
    calendarTitle: "Staff Attendance Calendar",
    calendarSubtitle: "View monthly attendance by service provider and unit.",
    unit: "Unit",
    month_year: "Month & Year",
    empty: "No Staff Found.",
    search: "Search",
    date: "Date",
    type: "Type",
    sub_type: "Sub Type",
    service_provider: "Service Provider",
    present: "Present",
    absent: "Absent",
    pending: "Pending",
    attendance_percentage: "Attendance %",
    calendar_select_filters: "Select service provider and unit, then apply filters to view the calendar.",
    notMarked: "Not marked",
    attendance_marked: "Attendance Marked Successfully.",
    table_date: "DATE",
    table_type: "TYPE",
    table_sub_type: "SUB TYPE",
    table_status: "STATUS",
}

export default StaffAttendance;